import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=1b6fd58c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6fd58c')) {
      api.createRecord('1b6fd58c', component.options)
    } else {
      api.reload('1b6fd58c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=1b6fd58c&", function () {
      api.rerender('1b6fd58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ib6qkiS439YT/JS/imageCarousel.vue"
export default component.exports